import * as ACTIONS from "@iso/redux/reviews/actionTypes";

const initialState = {
  reviews: {
    list: [],
    total: 0,
  },
};

function reviewsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_REVIEWS_SUCCESS: {
      return {
        ...state,
        ...{ reviews: payload },
      };
    }
    default:
      return state;
  }
}

export default reviewsReducer;
